import React from "react";

import Jumbotron from "../Jumbotron";
import HomePosts from "./HomePosts";

function Home() {
    return(
        <div>
            <Jumbotron />
            <HomePosts isAuth={localStorage.getItem("isAuth")}/>
        </div>
    );
}

export default Home;